import { render, staticRenderFns } from "./GameModal.vue?vue&type=template&id=2a454a3a&"
import script from "./GameModal.vue?vue&type=script&lang=js&"
export * from "./GameModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports